import { Box } from "@mui/material";
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarColumnsButton, GridToolbarDensitySelector } from "@mui/x-data-grid-pro";

const GridToolbar = () => {
    return (
        <GridToolbarContainer sx={{ mt: '5px', justifyContent: 'end' }} role="toolbar">
            <Box sx={{ float: 'right', display: 'flex' }}>
                <GridToolbarFilterButton />
            </Box>
            <Box sx={{ float: 'right', display: 'flex' }}>
                <GridToolbarColumnsButton />
            </Box>
            <Box sx={{ float: 'right', display: 'flex' }}>
                <GridToolbarDensitySelector />
            </Box>
        </GridToolbarContainer>
    );
}

export default GridToolbar;